import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SideBar from './SideBar';
import HeaderUser from './HeaderUser';
import ForceProfileUpdate from '../ForceProfileUpdate';

const Main: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  // Pagali Food ocupa a largura toda (as outras páginas mantêm max-w-7xl).
  const larguraTotal = useLocation().pathname.startsWith('/food');

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-pagali-gray-50">
        <div className="text-center">
          <div className="spinner-lg mx-auto mb-4" />
          <p className="text-pagali-gray-500">A carregar...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-screen bg-pagali-gray-50 overflow-hidden">
      {/* Force Profile Update Modal */}
      <ForceProfileUpdate />

      {/* Sidebar */}
      <SideBar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <HeaderUser />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto">
          <div className={larguraTotal ? 'page-content-full' : 'page-content'}>
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <footer className="py-4 px-6 bg-white border-t border-pagali-gray-200">
          <p className="text-center text-xs text-pagali-gray-400">
            © {new Date().getFullYear()} Pagali - Todos os direitos reservados
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Main;
